export const MLA_ATTRIBUTE_EDIT_OPTION_LABEL = 'Edit Attribute';

export const COMMA_DELINEATOR = ',';
// add spacing to lists when they're displayed for end users
export const COMMA_DELINEATOR_DISPLAY = ', ';
